import { FormConfig } from '@shared/interfaces/form-configs/form-config';
import {
  CreateMeteringPointCommand,
  DisconnectionType,
  MeteringPointSubType,
  MeteringPointType,
  NetSettlementGroup,
  ObservationTimeSeriesPeriod,
  ProductCharacteristicIdentification,
  ProductCharacteristicUnitType,
  SettlementMethod
} from '@app/api/dmc';


export const meteringPointTypeTemplateConsumptionHourFormConfig: FormConfig<CreateMeteringPointCommand> = {
  'detailCharacteristics.meteringPointType': {
    value: MeteringPointType.Consumption,
  },
  'detailCharacteristics.productCharacteristicIdentification': {
    value: ProductCharacteristicIdentification.EnergyActive,
    state: 'required',
  },
  'detailCharacteristics.subType': {
    state: 'required',
    value: MeteringPointSubType.Virtual,
  },
  'detailCharacteristics.productCharacteristicUnitType': {
    value: ProductCharacteristicUnitType.KWH,
    state: 'required',
  },
  'detailCharacteristics.fromGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.toGridAreaId': {
    state: 'disabled',
  },
  'detailCharacteristics.netSettlementGroup': {
    state: 'required',
    value: NetSettlementGroup.NetSettlementGroup0,
  },
  'detailCharacteristics.disconnectionType': {
    state: 'required',
    value: DisconnectionType.ManualDisconnection,
  },
  'detailCharacteristics.settlementMethod': {
    state: 'required',
    value: SettlementMethod.NonProfiled,
  },
  'detailCharacteristics.meterReadingOccurrence': {
    state: 'required',
    value: ObservationTimeSeriesPeriod.Quarter,
  },
  'parentMeteringPointIdentification': {
    state: 'disabled',
  },
  'connectionPointId': {
    state: 'required',
  },
  // TS-Ignore necessary to reference a field that doesn't exist.
  // @ts-expect-error TS2353: extra property
  'connectionPointIdentification': {
    state: 'required',
    optional: true,
  },
  'connectionPointAddress': {
    state: 'required',
    optional: true,
  }
}
